export default "__VITE_ASSET__CgLzDlA8__"